module.exports = __webpack_public_path__ + "static/media/x-ray.a39d8505.svg";